import React from "react";
import "./HeroBg.scss";
import { motion } from "framer-motion";

function HeroBg(): JSX.Element {
  const logoAnimation = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.25,
        when: "beforeChildren",
        staggerChildren: 0.25,
        ease: "easeOut",
      }
    },
    none: { opacity: 1, transition: { duration: 0, staggerChildren: 0 } }
  }

  const logoPath = {
    hidden: { pathLength: 0, pathOffset: 1 },
    visible: { pathLength: 1, pathOffset: 0, transition: { duration: 0.35, ease: "easeInOut" } },
    none: { pathLength: 1, pathOffset: 0, transition: { duration: 0 } }
  }
  const svgRef = React.useRef(null);
  return (
    <div className="nimbus-web--hero-bg">
      <motion.svg ref={svgRef} xmlns="http://www.w3.org/2000/svg" variants={logoAnimation} initial="hidden" animate="visible" width="1920" height="1080" viewBox="0 0 1920 1080" preserveAspectRatio="xMinYMin slice" fill="none">
        <motion.path ref={svgRef} variants={logoPath} d="M-.35,31.06h1920" />
        <motion.path ref={svgRef} variants={logoPath} d="M-.35,64.94h1920" />
        <motion.path ref={svgRef} variants={logoPath} d="M-.35,177.88h1920" />
        <motion.path ref={svgRef} variants={logoPath} d="M-.35,290.82h1920" />
        <motion.path ref={svgRef} variants={logoPath} d="M-.35,403.76h1920" />
        <motion.path ref={svgRef} variants={logoPath} d="M55.41,0V1080" />
        <motion.path ref={svgRef} variants={logoPath} d="M349.06,0V1080" />
        <motion.path ref={svgRef} variants={logoPath} d="M406.94,0V1080" />
        <motion.path ref={svgRef} variants={logoPath} d="M700.59,0V1080" />
        <motion.path ref={svgRef} variants={logoPath} d="M1411.06,513.88h451.76A57.18,57.18,0,0,1,1920,571.06v451.76a57.18,57.18,0,0,1-57.18,57.18H1411.06a57.18,57.18,0,0,1-57.18-57.18V571.06A57.18,57.18,0,0,1,1411.06,513.88Z" />
        <motion.path ref={svgRef} variants={logoPath} d="M1411.05,513.88a57.18,57.18,0,1,1-57.17,57.18A57.18,57.18,0,0,1,1411.05,513.88Z" />
        <motion.path ref={svgRef} variants={logoPath} d="M1411.05,965.65a57.18,57.18,0,1,1-57.17,57.17A57.18,57.18,0,0,1,1411.05,965.65Z" />
        <motion.path ref={svgRef} variants={logoPath} d="M1862.82,513.88a57.18,57.18,0,1,1-57.17,57.18A57.18,57.18,0,0,1,1862.82,513.88Z" />
        <motion.path ref={svgRef} variants={logoPath} d="M1862.82,965.65a57.18,57.18,0,1,1-57.17,57.17A57.18,57.18,0,0,1,1862.82,965.65Z" />
        <motion.path ref={svgRef} variants={logoPath} d="M1468.23,513.17v566.12" />
        <motion.path ref={svgRef} variants={logoPath} d="M1805.64,513.17v566.12" />
        <motion.path ref={svgRef} variants={logoPath} d="M1919.29,628.23H1353.17" />
        <motion.path ref={svgRef} variants={logoPath} d="M1919.29,967.06H1353.17" />
      </motion.svg >
    </div>
  );
}

export default HeroBg;